(() => {
  document.documentElement.classList.add('sw-js');
  const initialize = (root = document) => {
    root.querySelectorAll('[data-sw-menu]').forEach((menu) => {
      if (menu.dataset.swReady) return;
      menu.dataset.swReady = 'true';
      const summary = menu.querySelector('summary');
      const reflect = () => summary.setAttribute('aria-expanded', String(menu.open));
      menu.addEventListener('toggle', reflect);
      reflect();
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          summary.focus();
        }
      });
      menu.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false;
      });
    });
    root.querySelectorAll('[data-sw-filters]').forEach((panel) => {
      if (panel.dataset.swReady) return;
      panel.dataset.swReady = 'true';
      panel.open = window.matchMedia('(min-width: 990px)').matches;
      const summary = panel.querySelector('summary');
      const reflect = () => summary.setAttribute('aria-expanded', String(panel.open));
      panel.addEventListener('toggle', reflect);
      reflect();
    });
    root.querySelectorAll('[data-sw-sort]').forEach((select) => {
      if (select.dataset.swReady) return;
      select.dataset.swReady = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
  };
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-sw-menu][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  initialize();
})();
